<template>
  <el-button type="primary" icon="el-icon-download">打印</el-button>
</template>

<script>
export default {
  name: 'PrintButton'
}
</script>

<style>
</style>
